import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IChartTooltipProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import Text from "../../../text";
import ChartKey from "../key";

const ChartTooltip: FC<IChartTooltipProps> = ({
    customTheme,
    children,
    style,
    title,
    rows,
    sum,
    ...props
}) => {
    const {
        controlPaddings,
        shapeConfigs,
        shadowAlpha,
        elevations,
        iconSizes,
        radiuses,
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle,
        divider: dividerDynamicStyle,
        value: valueDynamicStyle,
        row: rowDynamicStyle
    } = useStyles({
        controlPaddings,
        shapeConfigs,
        shadowAlpha,
        elevations,
        iconSizes,
        radiuses,
        borders,
        colors,
        spaces
    });

    const renderRow = ({
        title: rowTitle,
        shape = "line",
        colorIndex,
        value,
        key
    }: IChartTooltipProps["rows"][number]) => {
        return <View
            style={[
                stylesheet.row,
                rowDynamicStyle
            ]}
            key={key}
        >
            <ChartKey
                customTheme={customTheme}
                colorIndex={colorIndex}
                shape={shape}
            />
            <Text
                customTheme={customTheme}
                style={stylesheet.name}
                variant="bodySmallSize"
                numberOfLines={1}
                color="mid"
            >
                {rowTitle}
            </Text>
            <Text
                customTheme={customTheme}
                variant="titleSmallSize"
                style={[
                    stylesheet.value,
                    valueDynamicStyle
                ]}
                color="high"
            >
                {value}
            </Text>
        </View>;
    };

    const renderSum = () => {
        if(!sum) {
            return null;
        }

        return <>
            <View
                style={[
                    stylesheet.row,
                    rowDynamicStyle
                ]}
            >
                <Text
                    customTheme={customTheme}
                    variant="labelSmallSize"
                    style={stylesheet.name}
                    numberOfLines={1}
                    color="high"
                >
                    {sum.title}
                </Text>
                <Text
                    customTheme={customTheme}
                    variant="titleSmallSize"
                    style={[
                        stylesheet.value,
                        valueDynamicStyle
                    ]}
                    color="high"
                >
                    {sum.value}
                </Text>
            </View>
            <View
                style={dividerDynamicStyle}
            />
        </>;
    };

    const renderBody = () => {
        if(children) {
            return children;
        }

        return <>
            {
                title ?
                    <Text
                        customTheme={customTheme}
                        variant="bodySmallSize"
                        color="mid"
                    >
                        {title}
                    </Text>
                :
                    null
            }
            {renderSum()}
            {rows.map(renderRow)}
        </>;
    };

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-hidden={true}
    >
        {renderBody()}
    </View>;
};
export default ChartTooltip;
